module.exports = __webpack_public_path__ + "img/illustrator-task.42f0c6d9.svg";